var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero",
  transform: "translate(0 6)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FED100",
  d: "M10.696 5.998a4.7 4.7 0 0 1 4.377 2.987 9.2 9.2 0 0 0-1.845 4.81h-.533c-1.408 0-2.707.47-3.748 1.261a4.698 4.698 0 0 1 1.75-9.058"
}), /*#__PURE__*/React.createElement("rect", {
  width: 4.498,
  height: 1.599,
  y: 9.896,
  fill: "#FED100",
  rx: 0.8
}), /*#__PURE__*/React.createElement("rect", {
  width: 4.498,
  height: 1.599,
  x: 2.474,
  y: 15.869,
  fill: "#FED100",
  rx: 0.8,
  transform: "rotate(-45 4.723 16.669)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 4.498,
  height: 1.599,
  x: 14.42,
  y: 3.923,
  fill: "#FED100",
  rx: 0.8,
  transform: "rotate(-45 16.669 4.723)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 4.498,
  height: 1.599,
  x: 2.474,
  y: 3.923,
  fill: "#FED100",
  rx: 0.8,
  transform: "rotate(45 4.723 4.723)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 1.599,
  height: 4.498,
  x: 9.896,
  fill: "#FED100",
  rx: 0.8
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M22.479 6.797a7.79 7.79 0 0 1 7.34 5.188l.416 1.174 1.23-.192q.455-.072.923-.072a5.898 5.898 0 1 1 0 11.796H12.695a4.698 4.698 0 1 1 0-9.397h1.912l.115-1.374a7.785 7.785 0 0 1 7.756-7.123"
}))));
export { Svg2 as ReactComponent };